import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const StnRejView = () => {
   useAuthRedirect();
    const {stnNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  

  const canView  = hasPermission("Inward Reject", "view");


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
          Swal.fire({
                                title: "Fetching STN Inward Rejected Details",
                                html: `
                                  <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                                    <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                                  </div>
                                  <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch STN Inward Rejected Details...</p>
                                `,
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                didOpen: () => {
                                  const style = document.createElement("style");
                                  style.innerHTML = `
                                    @keyframes progressBar {
                                      0% { width: 0% }
                                      50% { width: 100% }
                                      100% { width: 0% }
                                    }
                                  `;
                                  document.head.appendChild(style);
                                },
                              });
                
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnInwardReject_detailsHeader?stnNo=${stnNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
              stnNumber: items[0].sfIssuesDetail_number || "N/A",
              stn_branch: items[0].stn_branch || "N/A",
                stn_now: items[0].sfIssuesHeader_date || "N/A",
                fromBranch: items[0].branchCode || "N/A",
                toBranch: items[0].sfIssuesHeader_branchcode || "N/A",
                stn_requbasis: items[0].stn_requbasis || "N/A",
                stn_headmet: items[0].stn_headmet || "N/A",
                stn_inref: items[0].stn_inref || "N/A",
                stn_remarks: items[0].stn_remarks || "N/A",
            };

            setHeader(storeReqHeader);
            setData(response.data.headerDetails);
        }
        Swal.close();
      } catch (error) {
         Swal.close();
                                console.error("Error fetching STN Inward Rejected Details. Please try again:", error);
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops!",
                                  text: "Error fetching STN Inward Rejected Details. Please try again",
                                });
      }
    };
{canView && (
    fetchIndentDetails()
)}
  }, [stnNo, branch]); 


if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                                  <h2 className="add-txt">STN - REJECT View</h2>
                                  <Link to={`/inventory/stn_inward_reject`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>STN Inward No :</label>
                <input type="text" name="indentNo" value={header.stnNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text"
                value={header.stn_now ? new Date(header.stn_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>From Branch :</label>
                <input type="text" name="type" value={header.fromBranch} readOnly />
              </div>
              <div className="form-group">
                <label>To Branch :</label>
                <input type="text" name="branch" value={header.toBranch} readOnly />
              </div>
            </div>
 
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Uom</th>
                    <th>Price</th>
                    <th>Quantity</th>

                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.sfissuesDetail_itemCode}</td>
                        <td>{item.sfissuesDetail_itemName}</td>
                        <td>{item.sfissuesDetail_uom}</td>
                        <td>{item.sfIssuesDetail_price}</td>
                        <td>{item.sfissuesDetail_issuedQuantity}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default StnRejView;
